import './LoaderStyle.css';

function Laoder() {
  return (
   
    <div className="loading">
      <div className='lds-ellipsis'>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    </div >
   
  );
}

export default Laoder;